import React from "react"
import { Typography, Card, Space } from "antd"

import { TYPE_NONE } from "@components/Form"
import { WIDTHS, isMobile } from "@components/constants"
import { ProfilesListInput } from "@components/Domain/Input"
import { ACCREDITATION_REFERENCE_URL } from "@components/Domain/Constants"

const { W0, W1 } = WIDTHS
const { Text, Link } = Typography

const LABEL_ACCOUNT_TITLE = "My Information"
const LABEL_EMAIL = "Email Address"
const LABEL_MOBILE = "Contact Phone Number"
const LABEL_LAST_NAME = "Legal Last Name"
const LABEL_FIRST_NAME = "Legal First Name"
const LABEL_ACCREDITATION = "Are you an accredited investor?"
const LABEL_ACCREDITATION_NOTE = `
A person is considered an accredited investor if (1) net worth exceeds $1
million, either individually or jointly with spouse or (2) have an annual
income exceeding $200,000, or $300,000 for joint income, for the last two
years. To find out more about accredited investors click here
`


const getInputs = (tiers, brokers) => {
  return [
    {
      name: "projectId",
      type: TYPE_NONE,
    },
    {
      name: "brokerUserId",
      type: TYPE_NONE,
    },
    {
      name: "investor",
      label: "",
      schema: [
        {
          name: "email",
          label: LABEL_EMAIL,
        },
        {
          name: "givenName",
          label: LABEL_FIRST_NAME
        },
        {
          name: "familyName",
          label: LABEL_LAST_NAME
        },
        {
          /* td: add validation for number to be not less then 10 chars */
          name: "mobileNumber",
          label: LABEL_MOBILE,
          required: true
        },
        {
          name: "hasAccreditation",
          label: LABEL_ACCREDITATION,
          itemProps: {
            style: { marginBottom: 0 },
            extra: (
              <Space
                size={0}
                direction="vertical"
                style={{ marginTop: W0, lineHeight: 1.2 }}
              >
                <Text
                  type="secondary"
                  style={{ fontSize: 12 }}
                >
                  {LABEL_ACCREDITATION_NOTE}:{' '}
                </Text>
                <Link
                  href={ACCREDITATION_REFERENCE_URL}
                  style={{ fontSize: 12 }}
                  target="_blank"
                >
                  {ACCREDITATION_REFERENCE_URL}
                </Link>
              </Space>
            ),
          },
          initialValue: null,
        }
      ],
      containerComponent: ({ children }) => (
        <Card
          type="inner"
          size={ isMobile ? "small" : "medium" }
          style={{ marginBottom: W1 }}
          title={LABEL_ACCOUNT_TITLE}
        >
          {children}
        </Card>
      ),
    },
    {
      name: "profiles",
      component: ProfilesListInput,
      componentProps: {
        tiers,
        brokers,
        initialValue: [{ investments: [] }]
      }
    }
  ]
}

export default getInputs
